import React from 'react';

const AboutSection = () => {
  return (
    <section className="sec sec--paper" id="about">
      <div className="shell">
        <div className="sec-head rv">
          <h2 className="h2">Who is Standard Auditing?</h2>
          <p className="answer">
            Standard Auditing is a Dubai based audit, tax and accounting firm working with UAE businesses since 2000.
            The practice is a member of the Emirates Association for Accountants and Auditors, carries professional
            indemnity insurance, and is registered or listed with the UAE free zone authorities named below.
          </p>
        </div>

        <dl className="facts rv">
          <div className="fact">
            <dt>Founded</dt>
            <dd>
              2000<small>Over 25 years working with UAE businesses</small>
            </dd>
          </div>
          <div className="fact">
            <dt>Engagements</dt>
            <dd>
              4,000+<small>Across audit, tax, VAT and bookkeeping</small>
            </dd>
          </div>
          <div className="fact">
            <dt>Clients</dt>
            <dd>
              500+<small>UAE mainland and free zone companies</small>
            </dd>
          </div>
          <div className="fact">
            <dt>Membership</dt>
            <dd>
              EAAA<small>Emirates Association for Accountants and Auditors</small>
            </dd>
          </div>
          <div className="fact">
            <dt>Office</dt>
            <dd>
              Al Hamriya, Dubai<small>NBQ Building 112, Khalid Bin Al Waleed Road</small>
            </dd>
          </div>
        </dl>

        <p className="support" style={{ marginTop: '26px', fontSize: '.9rem' }}>
          Registrations and memberships. We confirm the current status for your specific zone on the call.
        </p>
        <div className="zones rv" style={{ marginTop: '14px' }}>
          <span className="zone">DMCC</span>
          <span className="zone">DAFZA</span>
          <span className="zone">DIFC</span>
          <span className="zone">Meydan Free Zone</span>
          <span className="zone">SHAMS (Sharjah Media City)</span>
          <span className="zone">JAFZA</span>
          <span className="zone" style={{ borderStyle: 'dashed' }}>
            Dubai Chamber of Commerce (membership, not a free zone)
          </span>
        </div>

        {/* E-E-A-T authorship layer */}
        <div className="author rv">
          <div className="author-mark" aria-hidden="true">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2.5 4 6v6c0 4.6 3.3 8.4 8 9.5 4.7-1.1 8-4.9 8-9.5V6l-8-3.5Z"
                fill="rgba(205,152,48,.25)"
                stroke="#cd9830"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <path d="M8.6 12.2l2.3 2.3 4.5-4.7" stroke="#e2b350" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <h3>Reviewed by the Corporate Tax team at Standard Auditing</h3>
            <p>
              The tax positions described on this page are reviewed by the firm's Corporate Tax team against the Federal
              Decree Law No. 47 of 2022 and the Cabinet and Ministerial Decisions issued under it. Every client return is
              prepared and reviewed by a qualified accountant before it is submitted on EmaraTax.
            </p>
            <p>
              Nothing on this page is tax advice for a specific company. UAE Corporate Tax outcomes turn on your licence,
              your tax period, your substance and the elections made in the return, which is what the free review call is
              for.
            </p>
            <p className="meta">
              <span>
                <b>Last reviewed</b> 31 July 2026
              </span>
              <span>
                <b>Covers</b> tax periods from 1 June 2023
              </span>
              <span>
                <b>Jurisdiction</b> United Arab Emirates
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
